module.exports = __webpack_public_path__ + "img/product_cover.3bfa23eb.png";